module.exports = {
	"global": {
		"true": "Ja",
		"false": "Nein",
		"edit": "BEARBEITEN",
		"intentionally-left-blank": "Dieser Account kann genutzt werden um sich in die App einzuloggen"
	},
	"menu": {
		"home": "Home",
		"change-profile": "Profil",
		"change-password": "Passwort ändern",
		"logout": "Abmelden",
		"default": "Standard",
		"set_as_default": "Als Standard setzen"
	},
	"loginpage": {
		"login-title": "Zehnder-Portal Anmeldung",
		"username-placeholder": "Benutzername",
		"password-placeholder": "Passwort",
		"forgot-password": "Passwort vergessen?",
		"login-button": "ANMELDEN"
	},
	"backendselectorpage": {
		"title": "Bitte ein Produkt auswählen",
		"rememberchoice": "Als Standard setzen"
	},
	"homepage": {
		"nav": {
			"home": "Home",
			"mypresets": "Meine Voreinstellungen",
			"logs": "Logdateien"
		},
		"filter-placeholder": "Nach Namen suchen",
		"add-new-button": "NEU HINZUFÜGEN",
		"title-edit-variant": "Variante bearbeiten",
		"tabs": {
			"installer-companies-tab": "INSTALLATIONSBETRIEBE",
			"add-installer-company-tab": "INSTALLTIONSBETRIEB HINZUFÜGEN",
			"installers-tab": "INSTALLATEURE",
			"add-installer-tab": "INSTALLATEUR HINZUFÜGEN",
			"commercial-offers-tab": "KOMMERZIELLE ANGEBOTE",
			"filter-shops-tab": "FILTER SHOPS",
			"products-tab": "PRODUKTE VERWALTEN",
			"add-product-tab": "PRODUKT HINZUFÜGEN",
			"add-variant-tab": "VARIANTE HINZUFÜGEN",
			"softwareVersions-tab": "FIRMWARE VERWALTEN",
			"add-softwareVersion-tab": "FIRMWARE HINZUFÜGEN",
			"installer-tab": "INSTALLATEUR",
			"documents-tab": "DOKUMENTE"
		},
		"table-headers": {
			"username": "BENUTZERNAME",
			"email": "E-MAIL",
			"country2": "LAND",
			"companyName": "FIRMENNAME",
			"address": "ADRESSE",
			"phonenumber": "TELEFONNUMMER",
			"something": "SOMETHING",
			"productID": "PRODUCT_ID",
			"version": "VERSION",
			"releaseNotes": "Freigabe-Informationen",
			"name": "NAME",
			"edit": "",
			"edit-header": "",
			"beta2": "BETA",
			"productName": "PRODUCT"
		},
		"installer-editor": {
			"add-installer": "Installateur hinzufügen",
			"edit-installer": "Installateur bearbeiten",
			"save-button": "Sichern",
			"cancel-button": "Abbrechen",
			"username-label": "Benutzername",
			"email-label": "E-Mail Adresse",
			"phone-label": "Telefonnummer",
			"delete-label": "Löschen",
			"delete-title": "Einen Installateur löschen!",
			"change-password-title": "Passwort ändern",
			"new-password-label": "Neues Passwort",
			"new-password-placeholder": "Neues Passwort",
			"confirm-password-label": "Passwort bestätigen",
			"confirm-password-placeholder": "Passwort bestätigen"
		},
		"installer-company-editor": {
			"add-installer-company": "Installationsbetrieb hinzufügen",
			"edit-installer-company": "Installationsbetrieb bearbeiten",
			"save-button": "Sichern",
			"cancel-button": "Abbrechen",
			"username-label": "Benutzername",
			"email-label": "E-Mail Adresse",
			"companyName-label": "Firmenname",
			"address-label": "Adresse",
			"country-label": "Land",
			"delete-label": "Löschen",
			"delete-title": "Einen Installationsbetrieb löschen!",
			"change-password-title": "Passwort ändern",
			"beta-label": "Beta",
			"new-password-label": "Neues Passwort",
			"new-password-placeholder": "Neues Passwort",
			"confirm-password-label": "Passwort bestätigen",
			"confirm-password-placeholder": "Passwort bestätigen",
			"you-are-about-to-delete": "Löschen: ",
			"sure": "Sicher?",
			"empty-ic-name": "Bitte Name der Installationsbetrieb eintragen",
			"invalid-email": "E-Mail Adresse nicht korrekt.",
			"pick": "Wählen...",
			"email-confirm-label": "E-Mail Adresse bestätigen",
			"email-confirm-incorrect": "Die E-Mail Adressen stimmen nicht überein"
		},
		"commercial-offers": {
			"title": "Kommerzielle Angebote",
			"save-button": "Änderungen sichern",
			"activation-date-placeholder": "Aktivierungs-Datum",
			"end-date-placeholder": "End-Datum"
		},
		"filter-shops": {
			"title": "Filtershops",
			"save-button": "Änderungen sichern"
		},
		"product-editor": {
			"add-product": "Produkt hinzufügen",
			"edit-product": "Produkt bearbeiten",
			"save-button": "Sichern",
			"cancel-button": "Abbrechen",
			"delete-label": "Löschen",
			"productID-label": "Produkt ID",
			"name-label": "Produktname",
			"articlePrefix-label": "Artikel Prefix",
			"table-headers": {
				"variantID": "VARIANTEN_ID",
				"name": "NAME",
				"edit": "BEARBEITEN"
			},
			"filter-placeholder": "Nach Namen suchen",
			"add-new-button": "NEUE VARIANTE",
			"add-variant": "Variante hinzufügen",
			"edit-variant": "Variante bearbeiten",
			"delete-title": "Ein Produkt löschen!"
		},
		"softwareVersion-editor": {
			"add-softwareVersion": "Firmwareversion hinzufügen",
			"edit-softwareVersion": "Firmewareversion bearbeiten",
			"filter-placeholder": "Suchen",
			"delete-label": "Firmwareversion löschen",
			"version-label": "Version",
			"releaseNotes-label": "Freigabe Informationen",
			"product-label": "Produkt",
			"save-button": "Sichern",
			"cancel-button": "Abbrechen",
			"delete-title": "Löschen einer Firmwareversion!",
			"name-label": "Name",
			"md5-label": "Md5",
			"choose-binary": "Binärdatei auswählen",
			"binary-label": "Binär",
			"beta-label": "Beta",
			"country-label": "Land",
			"table-headers": {
				"blockID": "BlockID",
				"name": "Name",
				"url": "URL",
				"size": "Grösse",
				"md5": "md5",
				"articleIDs": "Artikel",
				"edit": "Bearbeiten",
				"delete": "Löschen"
			}
		},
		"documents-panel": {
			"title": "Dokumente",
			"add-new-button": "Neu hinzufügen",
			"documents-list": {
				"delete-label": "Löschen",
				"delete-title": "Dokument löschen",
				"save-button": "Sichern",
				"cancel-button": "Abbrechen"
			},
			"download": "Herunterladen"
		},
		"document-editor": {
			"add-document": "Dokument hinzufügen",
			"save-button": "Sichern",
			"cancel-button": "Abbrechen",
			"name-label": "Name",
			"description-label": "Beschreibung",
			"type-label": "Typ",
			"url-label": "Webadresse (URL)",
			"file-label": "Datei",
			"choose-file": "Datei auswählen",
			"model-label": "Modell",
			"country-label": "Land",
			"tabs": {
				"url-tab": "Webadresse (URL)",
				"upload-tab": "Datei"
			},
			"no-name-entered": "Bitte Name der Dokument eintragen",
			"no-description-entered": "Bitte Beschreibung der Dokument eintragen"
		}
	},
	"passwordpage": {
		"nav": {
			"home": "Home",
			"mypresets": "Meine Voreinstellungen",
			"logs": "Log-Dateien"
		},
		"title": "Passwort ändern",
		"new-password-placeholder": "Neues Passwort",
		"confirm-password-placeholder": "Passwort bestätigen"
	},
	"forgotpasswordpage": {
		"title": "Anfrage zum Zurücksetzen des Passwortes",
		"email-label": "E-Mail Adresse",
		"send-email-button": "Sende E-Mail",
		"password-requested-message": "Passwort-Reset-Anfrage E-Mail gesendet an",
		"save-button": "Ändern",
		"cancel-button": "Abbrechen"
	},
	"changepasswordpage": {
		"title": "Passwort ändern",
		"current-password-label": "Aktuelles Passwort",
		"current-password-placeholder": "Aktuelles Passwort",
		"new-password-label": "Neues Passwort",
		"new-password-placeholder": "Neues Passwort",
		"confirm-password-label": "Passwort wiederholen",
		"confirm-password-placeholder": "Passwort wiederholen",
		"save-button": "Passwort ändern",
		"cancel-button": "Abbrechen",
		"change-password-label": "Passwort ändern",
		"change-password-description": "Das Passwort muss mindesten 8 Zeichen lang sein, einen Buchstaben, einen Grossbuchstaben eine Ziffer und ein Sonderzeichen enthalten.",
		"change-password-current": "Bitte das aktuelle Passwort eingeben.",
		"change-password-confirm": "Bitte das neue Passwort bestätigen."
	},
	"profilepage": {
		"title": "Profilseite",
		"companyName-label": "Firmenname",
		"email-label": "E-Mail",
		"address-label": "Adresse",
		"language-label": "Bevorzugte Sprache",
		"save-button": "Sichern",
		"cancel-button": "Abbrechen"
	},
	"country": {
		"BELGIUM": "Belgien",
		"NETHERLANDS": "Niederlande",
		"GERMANY": "Deutschland",
		"UNITED_KINGDOM": "Grossbritannien",
		"FRANCE": "Frankreich",
		"AUSTRIA": "Österreich",
		"POLAND": "Polen",
		"SWITZERLAND": "Schweiz",
		"ITALY": "Italien",
		"SPAIN": "Spanien",
		"NORTH_AMERICA": "Nordamerika",
		"ALL_COUNTRIES": "Alle Länder",
		"OTHER_COUNTRIES": "Andere Länder"
	},
	"table": {
		"no-data-message": "Keine Daten verfügbar"
	},
	"error": {
		"login": {
			"invalid": "Benutzername und/oder Passwort nicht korrekt.",
			"error": "Fehler bei der Verbindung zum Server.",
			"no_products": "Dieser Account hat keinen Zugang zu einem Zehnder-Produkt."
		},
		"password": {
			"change-failed": "Passwortänderung fehlgeschlagen",
			"update-failed": "Sie sind nicht angemeldet oder Sie nutzen unterschiedliche Internet-Browser",
			"user-not-found": "Ein Nutzer mit dieser E-Mail Adresse kann nicht gefunden werden",
			"insecure": "Das Passwort muss mindestens aus 8 Zeichen, einem Grossbuchstaben, einer Zahl und einem Sonderzeichen bestehen",
			"too-short": "Das Passwort muss mindestens aus 8 Zeichen bestehen",
			"mismatch": "Das aktuelle Passwort ist nicht korrekt",
			"password-changed": "Das Passwort wurde erfolgreich geändert",
			"dontmatch": "Die Passwörter stimmen nicht überein",
			"password-not-changed": "Das eingegebene neue Passwort entspricht dem bisherigen "
		},
		"manager": {
			"no-access": "Sie haben keinen Zugang zu den Verwaltungs-Informationen",
			"load-fail": "Zugang zu den Verwaltungs-Informationen fehlgeschlagen"
		},
		"installer": {
			"no-access": "Sie haben keinen Zugang zu den Informationen der Installateure",
			"load-fail": "Laden der Informationen zu den Installateuren fehlgeschlagen",
			"duplicate": "Ein Eintrag zu einem Installateur unter dieser Bezeichnung oder E-Mail Adresse existiert bereits",
			"wrong-company": "Installateur ist bereits vorhanden und verbunden mit einem anderen Unternehmen",
			"add-failed": "Hinzufügen der Einträge zum Installateur fehlgeschlagen",
			"update-failed": "Änderung der Einträge zum Installateur fehlgeschlagen",
			"removed-failed": "Entfernen des Eintrags zum Installateur fehlgeschlagen"
		},
		"installer-company": {
			"no-access": "Sie habe keinen Zugriff auf die Einträge zu Installationsbetrieben",
			"load-fail": "Die Einträge zu den Installationsbetrieben konnten nicht abgerufen werden.",
			"conflict": "Nutzername und e-Mail Adresse müssen einzigartig sein.",
			"duplicate": "Ein Installationsbetrieb mit diesem Benutzernamen/dieser E-Mail Adresse existiert bereits.",
			"add-failed": "Hinzufügen des Installateur-Eintrages fehlgeschlagen",
			"update-failed": "Die Änderungen konnten nicht durchgeführt werden.",
			"removed-failed": "Entfernen des Eintrages fehlgeschlagen",
			"add-success": "Der Installationsbetrieb wurde hinzugefügt. Die E-Mail zur Verifikation wurde versendet.",
			"password-change": {
				"no-access": "Sie können das Passwort des Installationsbetriebes nicht verändern.",
				"failed": "Passwortänderung fehlgeschlagen",
				"success": "Das Passwort wurde erfolgreich geändert"
			}
		},
		"softwareversion": {
			"no-access": "Sie haben keinen Zugriff auf die Verwaltung der Firmwareversionen",
			"load-fail": "Laden der Firmwareversionen fehgeschlagen",
			"duplicate": "Eine Software unter dieser Versionsbezeichnung existiert bereits",
			"add-failed": "Hinzufügen der Firmwareversion fehlgeschlagen",
			"update-failed": "Update der Firmwareversion fehlgeschlagen",
			"removed-failed": "Entfernen der Firmwareversion fehlgeschlagen"
		},
		"product": {
			"no-access": "Sie haben keinen Zugriff auf die Produktverwaltung",
			"load-fail": "Die Produkte konnten nicht abgerufen werden",
			"add-failed": "Das Hinzufügen des Produktes ist fehlgeschlagen",
			"update-failed": "Das Update des Produktes ist fehlgeschlagen",
			"removed-failed": "Das Entfernen des Produktes ist fehlgeschlagen"
		},
		"commercial-offer": {
			"no-access": "Sie haben keinen Zugriff auf die kommerziellen Angebote",
			"load-failed": "Das Abrufen der kommerziellen Angebote ist fehlgeschlagen",
			"add-failed": "Das kommerzielle Angebot konnte nicht hinzugefügt werden"
		},
		"filtershop": {
			"no-access": "Sie haben keinen Zugriff auf die Filter-Shops",
			"load-failed": "Das Abrufen der Filter-Shops ist fehlgeschlagen",
			"add-failed": "Das Hinzufügen des Filter-Shops ist fehlgeschlagen"
		},
		"documents": {
			"no-access": "Sie haben keinen Zugriff auf die Dokumente",
			"load-failed": "Das Abrufen der Dokumente ist fehlgeschlagen",
			"add-failed": "Das Dokument konnte nicht hinzugefügt werden",
			"change-position-fail": "Die Reihenfolge der Dokumente konnte nicht verändert werden",
			"invalid-url": "Die Webadresse (URL) ist nicht gültig"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /locales/de.json
// module id = 1307
// module chunks = 0